import { Pickable } from '@app/engine/core/interfaces';
import { CruncerMessageTypes } from '@app/webworker/positionCruncher';
import { SpaceObjectType } from '@ootk/src/main';
import { CameraType } from '../../camera/camera';
import { ServiceLocator } from '@app/engine/core/service-locator';
export class ColorScheme {
    colorTheme = {};
    objectTypeFlags;
    static uniqueColorTheme;
    static uniqueObjectTypeFlags;
    layersHtml = '';
    /** This is used in the UI */
    label = 'Default Color Scheme';
    /** This is used in code for matching. Must be the class name. */
    id = 'ColorScheme';
    /** This is used in code for matching. Must be the class name. */
    static id = 'ColorScheme';
    isOptionInColorMenu = true;
    isOptionInRmbMenu = true;
    constructor(uniqueColorTheme) {
        // Ensure that settingsManager.colors are all defined
        for (const color in uniqueColorTheme) {
            if (!settingsManager.colors[color]) {
                settingsManager.colors[color] = uniqueColorTheme[color];
            }
        }
        this.colorTheme = {
            ...this.colorTheme, ...uniqueColorTheme,
        };
        for (const color in settingsManager.colors) {
            // If it is an array then it is a color
            if (Array.isArray(settingsManager.colors[color])) {
                this.colorTheme[color] = settingsManager.colors[color];
            }
        }
        this.objectTypeFlags = {
            facility: true,
            missile: true,
            missileInview: true,
            starLow: true,
            starMed: true,
            starHi: true,
        };
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    updateGroup(obj, _params) {
        if (!ServiceLocator.getGroupsManager().selectedGroup.hasObject(obj.id)) {
            // Hide Everything Else
            return {
                color: settingsManager.colors.transparent ?? this.colorTheme.transparent,
                pickable: Pickable.No,
            };
        }
        return this.update(obj, _params);
    }
    resetObjectTypeFlags() {
        for (const key in this.objectTypeFlags) {
            if (Object.prototype.hasOwnProperty.call(this.objectTypeFlags, key)) {
                this.objectTypeFlags[key] = true;
            }
        }
    }
    // This is called when the color scheme is selected
    onSelected() {
        const catalogManagerInstance = ServiceLocator.getCatalogManager();
        catalogManagerInstance.satCruncher.postMessage({
            isSunlightView: false,
            typ: CruncerMessageTypes.SUNLIGHT_VIEW,
        });
    }
    calculateParams() {
        return null;
    }
    checkFacility_(sat) {
        // Let's see if we can determine color based on the object type
        switch (sat.type) {
            case SpaceObjectType.INTERGOVERNMENTAL_ORGANIZATION:
            case SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR:
            case SpaceObjectType.PAYLOAD_OWNER:
            case SpaceObjectType.METEOROLOGICAL_ROCKET_LAUNCH_AGENCY_OR_MANUFACTURER:
            case SpaceObjectType.PAYLOAD_MANUFACTURER:
            case SpaceObjectType.LAUNCH_AGENCY:
            case SpaceObjectType.CONTROL_FACILITY:
                // If the facility flag is off then we don't want to show this
                if (!settingsManager.isShowAgencies || this.objectTypeFlags.facility === false || ServiceLocator.getMainCamera().cameraType === CameraType.PLANETARIUM) {
                    return {
                        color: this.colorTheme.deselected,
                        pickable: Pickable.No,
                    };
                    // Otherwise we want to show it
                }
                return {
                    color: this.colorTheme.starHi,
                    pickable: Pickable.Yes,
                };
            case SpaceObjectType.LAUNCH_SITE:
            case SpaceObjectType.LAUNCH_POSITION:
            case SpaceObjectType.LAUNCH_FACILITY:
                // If the facility flag is off then we don't want to show this
                if (settingsManager.isDisableLaunchSites || this.objectTypeFlags.facility === false || ServiceLocator.getMainCamera().cameraType === CameraType.PLANETARIUM) {
                    return {
                        color: this.colorTheme.deselected,
                        pickable: Pickable.No,
                    };
                    // Otherwise we want to show it
                }
                return {
                    color: this.colorTheme.facility,
                    pickable: Pickable.Yes,
                };
            default: // Since it wasn't one of those continue on
        }
        return null;
    }
    getMarkerColor_() {
        return {
            // TODO: Use this for Santa Tracker
            color: [1, 0, 0, 1],
            marker: true,
            pickable: Pickable.No,
        };
    }
    missileColor_(missile) {
        const dotsManagerInstance = ServiceLocator.getDotsManager();
        if (dotsManagerInstance.inViewData?.[missile.id] === 0) {
            if (this.objectTypeFlags.missile === false) {
                return {
                    color: this.colorTheme.deselected,
                    pickable: Pickable.No,
                };
            }
            return {
                color: this.colorTheme.missile,
                pickable: Pickable.Yes,
            };
        }
        if (this.objectTypeFlags.missileInview === false || !missile.active) {
            return {
                color: this.colorTheme.deselected,
                pickable: Pickable.No,
            };
        }
        return {
            color: this.colorTheme.missileInview,
            pickable: Pickable.Yes,
        };
    }
    starColor_(sat) {
        if (!sat.vmag) {
            return {
                color: this.colorTheme.deselected,
                pickable: Pickable.No,
            };
        }
        if (sat.vmag >= 4.7 && this.objectTypeFlags.starLow) {
            return {
                color: this.colorTheme.starLow,
                pickable: Pickable.Yes,
            };
        }
        else if (sat.vmag >= 3.5 && sat.vmag < 4.7 && this.objectTypeFlags.starMed) {
            return {
                color: this.colorTheme.starMed,
                pickable: Pickable.Yes,
            };
        }
        else if (sat.vmag < 3.5 && this.objectTypeFlags.starHi) {
            return {
                color: this.colorTheme.starHi,
                pickable: Pickable.Yes,
            };
        }
        // Deselected
        return {
            color: this.colorTheme.deselected,
            pickable: Pickable.No,
        };
    }
}
